// Ported from packages/desk/src/mobile/Widget.tsx (docs/PLAN-2026-09-21-mobile-os-shell.md, step 4). Same file name and props
// as the desk copy, the dk- prefix renamed rdr-, so a fix in one is a copy in the other. Radar never imports @gamo/desk.
/** A compact glass card on the home screen: an icon, a title, one live line, a chevron. It always goes somewhere. */
import { ChevronGlyph } from "./glyphs";
import type { MobileWidget } from "./types";

export function Widget({ widget }: { widget: MobileWidget }) {
  return (
    <button type="button" className={"rdr-mwidget" + (widget.tone === "accent" ? " accent" : "")} data-rdr-widget={widget.id} onClick={widget.onOpen}>
      <span className="rdr-mwidget-ic" aria-hidden="true">
        {widget.icon}
      </span>
      <span className="rdr-mwidget-text">
        <span className="rdr-mwidget-title">{widget.title}</span>
        <span className="rdr-mwidget-line">{widget.line}</span>
      </span>
      <span className="rdr-mwidget-go" aria-hidden="true">
        <ChevronGlyph />
      </span>
    </button>
  );
}
